"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcreditcard = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 63 54",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcreditcard` : '') + (description ? ` desc-brandedcreditcard` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcreditcard"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcreditcard"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.69 18.56c-.3-.95.28-1.97 1.28-2.28L50.01 1.9c1-.3 2.05.22 2.34 1.17l9.47 30.98c.3.95-.28 1.97-1.28 2.28L13.5 50.7c-1 .3-2.05-.22-2.34-1.17L1.69 18.56Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.42 30.54 3.05 23l50.3-16.13 2.37 7.05-50.3 16.62Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 22.65c0-.91.83-1.65 1.86-1.65h48.28c1.03 0 1.86.74 1.86 1.65v29.7c0 .91-.83 1.65-1.86 1.65H12.86c-1.03 0-1.86-.74-1.86-1.65v-29.7Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.69 54h48.6c.95 0 1.71-.74 1.71-1.65v-29.7c0-.91-.77-1.65-1.7-1.65H55C43.7 35.34 29.02 46.75 11.5 53.5c0 0 .5.5 1.19.5Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M59 32.91V29.1c0-.6-.5-1.09-1.12-1.09h-4.76A1.1 1.1 0 0 0 52 29.09v3.82c0 .6.5 1.09 1.12 1.09h4.76A1.1 1.1 0 0 0 59 32.91Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "15",
    y: "47",
    width: "8",
    height: "3",
    rx: "1.5",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "25",
    y: "47",
    width: "8",
    height: "3",
    rx: "1.5",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "35",
    y: "47",
    width: "8",
    height: "3",
    rx: "1.5",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "45",
    y: "47",
    width: "8",
    height: "3",
    rx: "1.5",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedcreditcard;